import { ArrowRightIcon } from 'lucide-react';
import { brandRoutes, hotTubLinks } from '../data/site';
import { SiteLink } from './SiteLink';
export function HotTubs() {
  return <section aria-labelledby="hot-tubs-heading" className="w-full bg-water" data-id="element-108" data-mp="dwis647i48wp">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-16" data-id="element-109" data-mp="3vaei9mzmtlcn">
        <div className="max-w-3xl" data-id="element-110" data-mp="43l65o3aw1tc">
          <p className="text-[14px] font-bold uppercase text-pegasus-blue" data-id="element-111" data-mp="42tjj2rolef7">Hot Tubs</p>
          <h2 id="hot-tubs-heading" className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-112" data-mp="3m8oi9srope39">
            Find a Hot Tub That Fits the Way You Live
          </h2>
          <p className="mt-4 text-body text-ink/80 sm:text-body-lg" data-id="element-113" data-mp="3ce6b2dn270ep">
            Start with the experience you want: everyday relaxation, hydrotherapy, family time or an
            easy-to-own first spa. Explore the brands and available models, then visit Pegasus for
            practical guidance.
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-114" data-mp="1x2hri7ihcl7">
          {brandRoutes.map(brand => <li key={brand.name} data-id="element-115" data-mp="3t45bagatnuyl">
              <SiteLink to={brand.href} className="group flex h-full flex-col overflow-hidden rounded-card border border-ink/10 bg-white transition-colors duration-150 ease-out hover:border-pegasus-blue" data-id="element-116" data-mp="3t33xw56c2wdp">
                <div className="aspect-[3/2] w-full" data-id="element-117" data-mp="3f3m2h6yj8kvd">
                  <img src={brand.image} alt={brand.alt} className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-118" data-mp="3f4498xitmhhj" />
                </div>
                <div className="flex flex-1 flex-col p-6" data-id="element-119" data-mp="3k1vzzo7qbxk5">
                  <h3 className="text-[26px] font-semibold leading-8 text-ink" data-id="element-120" data-mp="13ebe07pnh4d1">{brand.name}</h3>
                  <p className="mt-2 text-[16px] leading-6 text-ink/75" data-id="element-121" data-mp="13g5wzghd2meh">{brand.description}</p>
                  <span className="mt-auto pt-4 inline-flex items-center gap-1.5 text-[15.5px] font-bold text-pegasus-blue group-hover:text-pegasus-magenta" data-id="element-122" data-mp="zf2iaxb1uweu">
                    Explore {brand.name}
                    <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-123" data-mp="12q9z5bvhsb8" />
                  </span>
                </div>
              </SiteLink>
            </li>)}
        </ul>

        <ul className="mt-7 flex flex-col gap-x-8 gap-y-1 sm:flex-row sm:flex-wrap sm:items-center" data-id="element-124" data-mp="9zhc9zh0q3e9">
          {hotTubLinks.map(link => <li key={link.label} data-id="element-125" data-mp="3efa1vu72db7d">
              <SiteLink to={link.href} className="inline-flex min-h-[44px] items-center gap-1.5 text-[16px] font-medium text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta hover:decoration-pegasus-magenta" data-id="element-126" data-mp="3egbfa5bjy9s9">
                {link.label}
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-127" data-mp="2ur14n5qnyf10" />
              </SiteLink>
            </li>)}
        </ul>
      </div>
    </section>;
}